import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonVariant, InputVariant } from '@amobee/component-library';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'toolbar-input',
    templateUrl: './toolbar-input.component.html'
})
export class ToolbarInputComponent {
    @Input() public hide?: boolean = false;
    @Output() public onSearchTextChange = new EventEmitter<String>();
    public searchProps = {
        compact: false,
        variant: InputVariant.TABLE,
        leftElement: 'Search',
        placeholder: 'Search',
        showRightElement: 'whenFilledOnHover',
        rightElement: {
            variant: ButtonVariant.BORDERLESS,
            ultraCompact: true,
            icon: 'Remove'
        },
        searchString: new FormControl()
    };

    handleOnSearchTextChange($event: KeyboardEvent) {
        if ($event.key == 'Enter') {
            // trigger query update once user press 'Enter'
            this.onSearchTextChange.emit(this.searchProps.searchString.value);
        }
    }

    handleOnRemoveSearchText() {
        this.searchProps.searchString.setValue('');
        this.onSearchTextChange.emit(this.searchProps.searchString.value);
    }
}